'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Dateiupload = require('../entity').Dateiupload;

module.exports = function (connection) {
  return {
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Dateiupload, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Dateiupload, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('dateiupload')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/dateiupload.js
// module id = XC7J
// module chunks = 0